// 业务类型公共配置：value 为后端枚举值，label 为前端展示文案
export const BUSINESS_TYPE_OPTIONS = [
  {
    value: 'general',
    label: '通用类'
  },
  {
    value: 'collection',
    label: '催收类'
  },
  {
    value: 'marketing',
    label: '营销类'
  },
  {
    value: 'fraud',
    label: '反欺诈类'
  },
  {
    value: 'collection-two',
    label: '催收场景-02类'
  },
  {
    value: 'pos',
    label: '营销POS类'
  },
  {
    value: 'insurance',
    label: '保险类'
  },
  {
    value: 'return-visit',
    label: '回访类'
  },
  {
    value: 'comprehensive-health',
    label: '大健康类'
  },
  {
    value: 'education',
    label: '教育类'
  },
  {
    value: 'e-commerce',
    label: '电商类'
  },
  {
    value: 'car-rental',
    label: '汽车租赁类'
  }
];

// value -> label 映射，便于把接口返回的枚举快速转成中文文案
export const BUSINESS_TYPE_LABEL_MAP = BUSINESS_TYPE_OPTIONS.reduce((map, item) => {
  map[item.value] = item.label;
  return map;
}, {});

// label -> value 反向映射，便于把已展示的中文文案转回枚举值
export const BUSINESS_TYPE_VALUE_MAP = BUSINESS_TYPE_OPTIONS.reduce((map, item) => {
  map[item.label] = item.value;
  return map;
}, {});

// 枚举值 -> 中文文案，未知值原样返回
export function getBusinessTypeLabel(value) {
  return BUSINESS_TYPE_LABEL_MAP[value] || value;
}

// 中文文案 -> 枚举值，未知值原样返回
export function getBusinessTypeValue(label) {
  return BUSINESS_TYPE_VALUE_MAP[label] || label;
}



// WEBPACK FOOTER //
// ./src/utils/business-type.js